import { DEFAULT_NOTIFICATION_TYPES } from '../../constants';
import {
  PAUSE_NOTIFICATIONS,
  priorityTypeToBlockerMap,
  REMOVE_NOTIFICATION,
  RESUME_NOTIFICATIONS,
  SET_NOTIFICATION
} from '../constants';
import makeSuccessNotificationPayload from './makeSuccessNotificationPayload';

export const setNotificationAction = (data) => {
  return {
    type: SET_NOTIFICATION,
    payload: { isShown: true, timeout: 5000, ...data }
  };
};

export const closeNotificationAction = () =>
  setNotificationAction({
    isShown: false,
    NotificationComponent: null
  });

export const removeNotificationAction = (payload) => {
  return { type: REMOVE_NOTIFICATION, payload };
};

export const pauseNotificationAction = (priority = 'REGULAR') => ({
  type: PAUSE_NOTIFICATIONS,
  payload: {
    priority: priorityTypeToBlockerMap[priority]
  }
});

export const resumeNotificationAction = (priority = 'REGULAR') => ({
  type: RESUME_NOTIFICATIONS,
  payload: {
    priority: priorityTypeToBlockerMap[priority]
  }
});

export const setErrorNotificationAction = (message, timeout) =>
  setNotificationAction({
    message,
    timeout,
    notificationType: DEFAULT_NOTIFICATION_TYPES.ERROR
  });

export const setSuccessNotificationAction = (data, timeout) =>
  setNotificationAction(makeSuccessNotificationPayload(data, timeout));

export const setInfoNotificationAction = (message, timeout) =>
  setNotificationAction({
    message,
    timeout,
    notificationType: DEFAULT_NOTIFICATION_TYPES.INFO
  });

export const setWarningNotificationAction = (message, timeout) =>
  setNotificationAction({
    message,
    timeout,
    notificationType: DEFAULT_NOTIFICATION_TYPES.WARNING
  });
